import "./index.css";
import React from "react";
import { CurrencyOptions } from "../../../../../../Constants/retailer";
import { formatPriceInput } from "../../../../../../Utils/utils";

export default function ProductPriceInput({ amount, territory, onChange }) {
  return (
    <div className="price-input">
      <label className="price-input__label" htmlFor="price-input">
        Price
      </label>
      <div className="price_input_container">
        <span className="price_input_unit">{CurrencyOptions[territory]}</span>
        <input
          className="form-control form-control-lg form-control-alt"
          type="number"
          name="price"
          value={formatPriceInput(amount)}
          placeholder="00.00"
          onChange={onChange}
          id="price-input"
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/super_products/components/Popup/components/ProductPriceInput/index.js